import { CanAdminBoardLoggedInUserType } from 'src/queryTypes/board/layout'

export const isBoardAdmin = (loggedInUser: CanAdminBoardLoggedInUserType) => {
  const { networkUser, boardUser } = loggedInUser

  if (networkUser.role === 'ADMIN') {
    return true
  }

  if (boardUser.__typename === 'BoardMember') {
    const { role } = boardUser
    return role === 'OWNER' || role === 'ADMIN'
  }

  if (boardUser.__typename === 'BoardViewer') {
    return true
  }

  return false
}

export const isLearner = (loggedInUser: CanAdminBoardLoggedInUserType) => {
  const { boardUser } = loggedInUser
  return boardUser.__typename === 'BoardMember' && boardUser.role === 'LEARNER'
}

export const isBoardOwner = (loggedInUser: CanAdminBoardLoggedInUserType) =>
  loggedInUser.boardUser.__typename === 'BoardMember' &&
  loggedInUser.boardUser.role === 'OWNER'
